export const setGtm = (w,d,s,l,i) => {
  w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);

  const scriptElement = document.createElement('noscript');
  scriptElement.innerHTML = `<iframe src='https://www.googletagmanager.com/ns.html?id=${i}' height='0' width='0' style='display:none;visibility:hidden'></iframe>`;
  d.body.insertBefore(scriptElement, d.body.firstElementChild);
}